import React from "react";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import DashboardCard from "../DashboardCard";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import { displayData } from "../../../utils/data";

const MdcDormantTrailers = (props) => {
  const { data } = props;

  if (!get(data, ["card9"])) {
    return null;
  }

  return (
    <DashboardCard
      title={I18n.get("dashboard_nbDormantTrailers")}
      size={sizes.small}
      style={{
        margin: "12px",
        minWidth: "275px",
        flexGrow: 1,
      }}
    >
      <Box
        className="flexCenter"
        style={{ justifyContent: "flex-start", height: "100%" }}
      >
        <Grid container direction="column" style={{ maxWidth: "200px" }}>
          <Grid
            item
            className="flexCenter"
            style={{ justifyContent: "center" }}
          >
            <img
              src={images.clockArrowIcon}
              alt="clock_icon"
              height="50px"
              style={{ marginRight: "9px" }}
            />
            <img
              src={images.trailerIconDarkGrey}
              alt="trailer_icon"
              height="35px"
              style={{ marginLeft: "9px" }}
            />
          </Grid>
          <Grid
            item
            style={{
              fontWeight: 500,
              fontSize: "2em",
              lineHeight: "30px",
              //color: colors.primary,
              color: colors.black87,
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            {displayData(get(data, ["card9"]))}
          </Grid>
        </Grid>
      </Box>
    </DashboardCard>
  );
};

export default MdcDormantTrailers;
